export const home = {
  hero: {
    title: 'Kuleta Matumaini kwa Wakimbizi Uganda',
    subtitle: 'Msaada wa dharura, huduma za afya, elimu, na makazi kwa jamii zilizo hatarini',
    donateButton: 'Toa Mchango',
    learnMoreButton: 'Jifunze Zaidi',
  },
  impact: {
    badge: 'Athari Yetu',
    title: 'Kubadilisha Maisha Kila Siku',
    subtitle: 'Nambari halisi nyuma ya mabadiliko halisi — kila nambari inawakilisha maisha yaliyoguswa, familia iliyosaidiwa, na mustakabali uliorejeshwa.',
    counters: {
      livesHelped: 'Maisha Yaliyosaidiwa',
      livesHelpedDesc: 'Watu binafsi na familia waliopokea msaada wa kibinadamu wa moja kwa moja',
      mealsProvided: 'Milo Iliyotolewa',
      mealsProvidedDesc: 'Milo yenye lishe iliyowasilishwa kwa familia zilizofurushwa na watoto',
      sheltersBuilt: 'Makazi Yaliyojengwa',
      sheltersBuiltDesc: 'Makazi salama na yenye heshima yaliyojengwa kwa familia zilizofurushwa',
      childrenEducated: 'Watoto Waliofundishwa',
      childrenEducatedDesc: 'Watoto waliopewa ufikiaji wa elimu bora licha ya kufurushwa',
    },
    growthTitle: 'Safari Yetu kwa Miaka',
    milestones: {
      founded: 'Ilianzishwa',
      expanded: 'Ilipanuliwa hadi mikoa 3',
      clinics: 'Kliniki 10 za Simu',
      schools: 'Shule 25 Zilizosaidiwa',
      shelters: 'Makazi 8,400 Yaliyojengwa',
    },
  },
  projects: {
    title: 'Miradi Yetu Inayoendelea',
    subtitle: 'Kufanya tofauti halisi katika maisha ya wakimbizi na jamii zilizo hatarini kupitia programu zilizolengwa na suluhisho endelevu.',
    viewProject: 'Tazama Mradi',
    viewAll: 'Tazama Miradi Yote',
    active: 'Inaendelea',
    completed: 'Imekamilika',
  },
  testimonials: {
    badge: 'Hadithi za Matumaini',
    title: 'Sauti Kutoka Uwanjani',
    subtitle: 'Sikia kutoka kwa watu ambao maisha yao yamebadilishwa kupitia msaada wako — kwa maneno yao wenyewe, picha, na video.',
    tabs: {
      all: 'Hadithi Zote',
      photo: 'Picha',
      video: 'Video',
      text: 'Maandishi',
    },
  },
  news: {
    title: 'Habari na Masasisho ya Hivi Karibuni',
    subtitle: 'Baki umejulishwa kuhusu shughuli zetu za hivi karibuni, hadithi za mafanikio, na masasisho kutoka uwanjani nchini Jamhuri ya Kidemokrasia ya Kongo',
    readMore: 'Soma Zaidi',
    viewAll: 'Tazama Habari na Masasisho Yote',
  },
  cta: {
    badge: 'Fanya Tofauti Leo',
    title: 'Msaada Wako Unaweza',
    titleItalic: 'Kubadilisha Maisha Milele',
    subtitle: 'Kila mchango, bila kujali ukubwa wake, unaleta matumaini, heshima, na mustakabali mzuri kwa wakimbizi na jamii zilizo hatarini nchini Jamhuri ya Kidemokrasia ya Kongo.',
    donateButton: 'Toa Mchango',
    secureText: 'Mchango salama kupitia Stripe na PayPal',
  },
};
